import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-plan-modal',
  template: `
    <h1 mat-dialog-title>Criar Novo Plano</h1>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nome do Plano</mat-label>
        <input matInput [(ngModel)]="planName" placeholder="Digite o nome do plano" />
      </mat-form-field>
    </div>
    <mat-dialog-actions align="end">
    <button mat-button class="cancel-button" (click)="onCancel()">Cancelar</button>
    <button mat-raised-button class="create-button" (click)="onCreate()">Criar</button>
      </mat-dialog-actions>
  `,
    styles: [`
        .full-width { width: 100%; }
        mat-dialog-actions { margin-top: 15px; }
      
        .create-button {
          background-color: #4CAF50; 
          color: white;
        }
      
        .create-button:hover {
          background-color: #45A049; 
        }
      
        .cancel-button {
        background-color:rgb(146, 0, 0); 
          color: white;
        }
      
        .cancel-button:hover {
            background-color:rgb(175, 12, 0); 
        }
      `]
    
})
export class CreatePlanModalComponent {
  planName: string = '';

  constructor(
    public dialogRef: MatDialogRef<CreatePlanModalComponent>
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    if (this.planName && this.planName.length <= 200) {
      this.dialogRef.close(this.planName);
    } else {
      alert('O nome do plano deve ter no máximo 200 caracteres.');}
  }
}
